// extracted by mini-css-extract-plugin
export default {"dialog":"modal_dialog__XEjyM","modal":"modal_modal__xJzcv"};